import { useCalendarTime } from "components/Dashboard/DoctorDashboard/views/one-one-sessions/contexts/CalendarTimeContext";
import moment from "moment-timezone";
import { createContext, useContext } from "react";
import { useTimeline } from "./hooks/useTimeline";

const CalendarTimelineContext = createContext<ReturnType<typeof useTimeline>>({
  startOfDay: moment(),
  time: {
    hour: 0,
    minutes: 0,
  },
  nowValue: 0,
});

export const CalendarTimelineContextProvider = ({ children }) => {
  const { currentCalendarTimezone } = useCalendarTime();

  const value = useTimeline(currentCalendarTimezone);
  return (
    <CalendarTimelineContext.Provider value={value}>
      {children}
    </CalendarTimelineContext.Provider>
  );
};

export const useCalendarTimeline = () => useContext(CalendarTimelineContext);
